<template>
  <brand-banner type="error" :closeable="false" class="brandBanner">
    <i18n :path="translationPath">
      <span slot="tryAgainMessage" class="link">
        <a @click="$emit('tryAgain')" v-text="$t('illion.uploadError.tryAgainMessage')" />
      </span>
      <span slot="tryAgain" class="link">
        <a @click="$emit('tryAgain')" v-text="$t('illion.uploadError.tryAgain')" />
      </span>
      <span slot="connectYourBankAccount" class="link">
        <a @click="$emit('tryAgain')" v-text="$t('illion.uploadError.connectYourBankAccount')" />
      </span>
      <span slot="manualUploadMessage" class="link">
        <a
          @click="$emit('switchToManualMode')"
          v-text="$t('illion.uploadError.manualUploadMessage')"
        />
      </span>
    </i18n>
  </brand-banner>
</template>
<script>
import BrandBanner from '@/components/BrandBanner';

export default {
  name: 'electronic-upload-error-banner',
  components: { BrandBanner },
  props: {
    translationPath: {
      type: String,
      required: true,
    },
  },
};
</script>
<style lang="sass" scoped>
.brandBanner
  margin: 0

.link
  text-decoration: underline
  cursor: pointer
</style>
